import { useEffect } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form/dist/types/form';

export const useFormPersist = <T extends {}>(
  name: string,
  { watch, setValue }: { setValue: UseFormSetValue<T>; watch: UseFormWatch<T> },
  excluded: (keyof T)[] = []
) => {
  const values = watch();

  useEffect(() => {
    const str = window.sessionStorage.getItem(name);
    if (str) {
      const values: T = JSON.parse(str);

      (Object.keys(values) as Array<any>).forEach((key) => {
        if (!excluded.includes(key)) {
          setValue(key, values[key]);
        }
      });
    }
  }, [name]);

  useEffect(() => {
    window.sessionStorage.setItem(name, JSON.stringify(values));
  });

  return {
    clear: () => window.sessionStorage.removeItem(name),
  };
};
